module.exports = __webpack_public_path__ + "static/media/privacy-policy.be1cbb39.pdf";